<div class="w-full h-full flex flex-col bg-gray-50 overflow-hidden ">
  <!-- Header -->
  <!-- Tabs -->
  <div class="flex-shrink-0 border-b border-gray-200">
    <div class="flex">
      <button (click)="changeTab('SERVICE')" class="px-6 py-3 font-semibold transition-colors border-b-2"
        [class]="activeTab() === 'SERVICE' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
        {{'SERVCSTR0001' | translate}}
      </button>
      <button (click)="changeTab('OPTION')" class="px-6 py-3 font-semibold transition-colors border-b-2"
        [class]="activeTab() === 'OPTION' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
        {{'SERVCSTR0002' | translate}}
      </button>
    </div>
  </div>

  <!-- Main Content Area -->
  <div
    class="flex-1 min-h-0 bg-white border-x border-b border-gray-200 rounded-b-2xl shadow-sm p-2 grid grid-cols-1 md:grid-cols-12 gap-2 overflow-hidden"
    style="height: calc(100vh - 120px);">
    <!-- Column 1: Main Category -->
    <div
      class="md:col-span-3 flex flex-col h-full bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div class="p-2 border-b border-gray-100 flex justify-between gap-2 bg-[#374151]">
        <div class="flex items-center gap-2 w-1/3">
          <h3 class=" text-gray-100 text-ellipsis">{{'SERVCSTR0003' | translate}}</h3>
        </div>
        <div class="flex items-center gap-2 w-2/3 justify-end">
          <button (click)="newService(main)"
            class="text-ellipsis p-[0.4rem] flex items-center justify-center  hover:text-indigo-600 hover:bg-indigo-50 rounded border border-gray-200 bg-white transition-all shadow-sm">
            {{'SERVCSTR0004' | translate}}
          </button>
          <button (click)="saveService(main)"
            [class]="checkedMainCount() <= 0 ? 'opacity-50 pointer-events-none' : 'opacity-100'"
            class="text-ellipsis p-[0.4rem] flex items-center justify-center  hover:text-green-600 hover:bg-green-50 rounded border border-gray-200 bg-white transition-all shadow-sm">
            {{'SERVCSTR0005' | translate}}
          </button>
          <button (click)="confirmDelete(main)"
            [class]="checkedMainCount() <= 0 ? 'opacity-50 pointer-events-none' : 'opacity-100'"
            class="text-ellipsis p-[0.4rem] flex items-center justify-center  hover:text-red-600 hover:bg-red-50 rounded border border-gray-200 bg-white transition-all shadow-sm">
            {{'SERVCSTR0006' | translate}}
          </button>
        </div>
      </div>

      <div class="px-4 py-2 bg-white border-b border-gray-100 flex items-center justify-end gap-2 opacity-0">
        <input type="checkbox" id="sameAsMain" class="rounded border-gray-300 text-purple-600 focus:ring-purple-500" />
        <label for="sameAsMain" class="font-medium cursor-pointer">{{'SERVCSTR0014' |
          translate}}</label>
      </div>

      <!-- Header Row -->
      <div class="grid grid-cols-12 bg-[#374151] border-b border-gray-200  text-gray-100  items-center">
        <div class="col-span-1 text-center flex justify-center items-center border-r p-[0.4rem]">
          <p-checkbox [(ngModel)]="headerMainChecked" [binary]="true" (onChange)="checkedAll(main)"></p-checkbox>
        </div>
        <div class="col-span-5 text-ellipsis border-r p-[0.4rem]">{{'SERVCSTR0007' | translate}}</div>
        <div class="col-span-3 text-ellipsis text-center border-r p-[0.4rem]">{{'SERVCSTR0008' | translate}}</div>
        <div class="col-span-3 text-center text-ellipsis p-[0.4rem]">{{'SERVCSTR0009' | translate}}</div>
      </div>

      <div class="flex-1 overflow-y-auto">
        @for (g of mainservices(); track g.l_CLASS_CD) {
        <div (click)="selectGroup(g)" class=" grid grid-cols-12 rounded-lg border transition-all cursor-pointer"
          [class]="selectedGroup()?.l_CLASS_CD === g.l_CLASS_CD
              ? 'bg-indigo-50 border-indigo-200 border-l-4 border-l-indigo-600 shadow-sm'
              : 'bg-white border-transparent hover:bg-gray-50 hover:border-gray-200'">
          <div class="col-span-1 text-center flex justify-center items-center border-r border-b p-[0.4rem]"
            (click)="$event.stopPropagation()">
            <p-checkbox [(ngModel)]="g.checked" [binary]="true" (ngModelChange)="changeCheck(main)"></p-checkbox>
          </div>

          @if(selectedGroup()?.l_CLASS_CD === g.l_CLASS_CD){
          <div class="col-span-5 border-r border-b p-[0.4rem]">
            <input type="text" [ngModel]="g.l_CLASS_NM" maxlength="20" [placeholder]="'SERVCSTR0036' | translate"
              (ngModelChange)="updateNodeValue('GROUP', g.l_CLASS_CD, 'l_CLASS_NM', $event)"
              class="w-full focus:bg-white outline-none h-[30px] text-ellipsis" pInputText
              [class]="selectedGroup()?.l_CLASS_CD === g.l_CLASS_CD ? 'text-indigo-900' : 'text-gray-700'" />
          </div>
          <div class="col-span-3 text-center border-r border-b p-[0.4rem]">
            <p-inputnumber inputId="integeronly" [min]="1" [max]="9999" [clamp]="true"
              [class]="selectedGroup()?.l_CLASS_CD === g.l_CLASS_CD ? 'text-indigo-900' : 'text-gray-700'"
              (click)="$event.stopPropagation()" [(ngModel)]="g.sort"
              inputStyleClass="w-full border-none focus:bg-white outline-none h-[30px]  text-center" />
          </div>
          <div class="col-span-3 text-center border-b p-[0.4rem]">
            <button
              (click)="$event.stopPropagation(); updateNodeValue('GROUP', g.l_CLASS_CD, 'usE_YN', g.usE_YN === 'Y' ? 'N' : 'Y')"
              class="w-16 py-1 rounded-md  transition-all border text-center" [class]="g.usE_YN === 'Y'
                ? 'bg-green-50 text-green-600 border-green-200 hover:bg-green-100'
                : 'bg-gray-50  border-gray-200 hover:bg-gray-100'">
              {{ (g.usE_YN === 'Y' ? 'SERVCEHQ0027' : 'SERVCEHQ0028') | translate }}
            </button>
          </div>
          }
          @else{
          <div class="col-span-5 border-r border-b p-[0.4rem]">
            <label class="w-full text-ellipsis ">{{ g.l_CLASS_NM}}</label>
          </div>
          <div class="col-span-3 text-center border-r border-b p-[0.4rem]">
            <label class="w-full text-ellipsis">{{ g.sort | number}}</label>
          </div>
          <div class="col-span-3 text-center border-b p-[0.4rem]">
            <label>{{ (g.usE_YN === 'Y' ? 'SERVCEHQ0027' : 'SERVCEHQ0028') | translate }}</label>
          </div>
          }
        </div>
        }
        @if (mainservices().length === 0) {
        <div class="p-8 text-center text-gray-400 ">{{'SYSMESER0004' | translate}}</div>
        }
      </div>
    </div>

    <!-- Column 2: Sub Category -->
    <div
      class="md:col-span-3 flex flex-col h-full bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden transition-opacity">
      <div class="p-2 border-b border-gray-100 flex justify-between items-center bg-[#374151]">
        <div class="flex items-center gap-2 w-1/3">
          <h3 class=" text-gray-100 text-ellipsis">{{'SERVCSTR0010' | translate}}</h3>
        </div>
        <div class="flex items-center gap-2 w-2/3 justify-end">
          <button (click)="newService(sub)"
            [class]="!selectedGroup()?.hQ_CD ? 'opacity-50 pointer-events-none' : 'opacity-100'"
            class="text-ellipsis p-[0.4rem] flex items-center justify-center  hover:text-indigo-600 hover:bg-indigo-50 rounded border border-gray-200 bg-white transition-all shadow-sm">
            {{'SERVCSTR0004' | translate}}
          </button>
          <button (click)="saveService(sub)"
            [class]="checkedSubCount() <= 0 ? 'opacity-50 pointer-events-none' : 'opacity-100'"
            class="text-ellipsis p-[0.4rem] flex items-center justify-center  hover:text-green-600 hover:bg-green-50 rounded border border-gray-200 bg-white transition-all shadow-sm">
            {{'SERVCSTR0005' | translate}}
          </button>
          <button (click)="confirmDelete(sub)"
            [class]="checkedSubCount() <= 0 ? 'opacity-50 pointer-events-none' : 'opacity-100'"
            class="text-ellipsis p-[0.4rem] flex items-center justify-center  hover:text-red-600 hover:bg-red-50 rounded border border-gray-200 bg-white transition-all shadow-sm">
            {{'SERVCSTR0006' | translate}}
          </button>
        </div>
      </div>

      @if(activeTab() == 'SERVICE'){
      <div class="px-4 py-2 bg-white border-b border-gray-100 flex items-center justify-end gap-2">
        <p-checkbox [(ngModel)]="sameMainServiceChecked" [binary]="true"></p-checkbox>
        <label for="sameAsMain" class="font-medium cursor-pointer">{{'SERVCSTR0014' |
          translate}}</label>
      </div>
      }
      @else {
         <div class="px-4 py-2 bg-white border-b border-gray-100 flex items-center justify-end gap-2">
        <p-checkbox [(ngModel)]="sameMainOptionChecked" [binary]="true"></p-checkbox>
        <label for="sameAsMain" class="font-medium cursor-pointer">{{'SERVCSTR0014' |
          translate}}</label>
      </div>
      }


      <!-- Header Row -->
      <div class="grid grid-cols-12 bg-[#374151] border-b border-gray-200   text-gray-100  items-center">
        <div class="col-span-1 text-center flex justify-center border-r  p-[0.4rem]">
          <p-checkbox [(ngModel)]="headerSubChecked" [binary]="true" (onChange)="checkedAll(sub)"></p-checkbox>
        </div>
        <div class="col-span-5 text-ellipsis border-r  p-[0.4rem]">{{'SERVCSTR0011' | translate}}</div>
        <div class="col-span-3 text-center text-ellipsis border-r  p-[0.4rem]">{{'SERVCSTR0012' | translate}}</div>
        <div class="col-span-3 text-center text-ellipsis p-[0.4rem]">{{'SERVCSTR0013' | translate}}</div>
      </div>

      <div class="flex-1 overflow-y-auto">
        @for (c of subServices(); track c.s_CLASS_CD) {
        <div (click)="selectCategory(c)" class="grid grid-cols-12 rounded-lg border transition-all cursor-pointer"
          [class]="selectedCategory()?.s_CLASS_CD === c.s_CLASS_CD
              ? 'bg-purple-50 border-purple-200 border-l-4 border-l-purple-500 shadow-sm'
              : 'bg-white border-transparent hover:bg-gray-50 hover:border-gray-200'">
          <div class="col-span-1 text-center items-center flex justify-center border-r border-b p-[0.4rem]"
            (click)="$event.stopPropagation()">
            <p-checkbox [(ngModel)]="c.checked" [binary]="true" (ngModelChange)="changeCheck(sub)"></p-checkbox>
          </div>


          @if(selectedCategory()?.s_CLASS_CD === c.s_CLASS_CD){
          <div class="col-span-5 border-r border-b p-[0.4rem]">
            <input type="text" [ngModel]="c.s_CLASS_NM" maxlength="20" pInputText
              (ngModelChange)="updateNodeValue('CATEGORY', c.s_CLASS_CD, 's_CLASS_NM', $event)"
              class="w-full focus:bg-white outline-none h-[30px]" [placeholder]="'SERVCSTR0036' | translate"
              [class]="selectedCategory()?.s_CLASS_CD === c.s_CLASS_CD ? 'text-purple-900' : 'text-gray-700'" />
          </div>
          <div class="col-span-3 border-r border-b p-[0.4rem]">
            <p-inputnumber inputId="integeronly" [min]="1" [max]="9999" [clamp]="true"
              [class]="selectedCategory()?.s_CLASS_CD === c.s_CLASS_CD ? 'text-purple-900' : 'text-gray-700'"
              (click)="$event.stopPropagation()" [(ngModel)]="c.sort"
              inputStyleClass="w-full border-none focus:bg-white outline-none h-[30px]  text-center" />
          </div>
          <div class="col-span-3 text-center border-b p-[0.4rem]">
            <button
              (click)="$event.stopPropagation(); updateNodeValue('CATEGORY', c.s_CLASS_CD, 'usE_YN', c.usE_YN === 'Y' ? 'N' : 'Y')"
              class="w-16 py-1 rounded-md   transition-all border text-center" [class]="c.usE_YN === 'Y'
                ? 'bg-green-50 text-green-600 border-green-200 hover:bg-green-100'
                : 'bg-gray-50  border-gray-200 hover:bg-gray-100'">
              {{ (c.usE_YN === 'Y' ? 'SERVCEHQ0027' : 'SERVCEHQ0028') | translate }}
            </button>
          </div>

          }
          @else{
          <div class="col-span-5 text-ellipsis border-r border-b p-[0.4rem]">
            <label class="w-full">{{ c.s_CLASS_NM}}</label>
          </div>
          <div class="col-span-3 text-center text-ellipsis border-r border-b p-[0.4rem]">
            <label class="w-full">{{ c.sort | number}}</label>
          </div>
          <label class="col-span-3 text-center border-b p-[0.4rem]"> {{ (c.usE_YN === 'Y' ? 'SERVCEHQ0027' :
            'SERVCEHQ0028') | translate
            }}</label>
          }

        </div>
        }
        @if (subServices().length === 0) {
        <div class="p-8 text-center text-gray-400 ">{{'SYSMESER0004' | translate}}</div>
        }
      </div>
    </div>

    <!-- Column 3: Option Settings -->
    <div
      class="md:col-span-6 flex flex-col h-full bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden transition-opacity">
      <div class="p-2 bg-[#374151] border-b border-gray-100 flex justify-between items-center">
        <div class="flex items-center gap-2">
          <label class=" fs-16 text-gray-100">{{'SERVCSTR0015' | translate}}</label>
        </div>
        <div class="flex items-center gap-[0.4rem]">
          <button (click)="newService(ser)"
            [class]="!selectedCategory()?.hQ_CD ? 'opacity-50 pointer-events-none' : 'opacity-100'"
            class="p-[0.4rem] flex items-center justify-center  hover:text-indigo-600 hover:bg-indigo-50 rounded border border-gray-200 bg-white transition-all shadow-sm">
            {{'SERVCSTR0004' | translate}}
          </button>
          <button (click)="saveService(ser)"
            [class]="checkedSerCount() <= 0 ? 'opacity-50 pointer-events-none' : 'opacity-100'"
            class="p-[0.4rem] flex items-center justify-center  hover:text-green-600 hover:bg-green-50 rounded border border-gray-200 bg-white transition-all shadow-sm">
            {{'SERVCSTR0005' | translate}}
          </button>
          <button (click)="confirmDelete(ser)"
            [class]="checkedSerCount() <= 0 ? 'opacity-50 pointer-events-none' : 'opacity-100'"
            class="p-[0.4rem] flex items-center justify-center  hover:text-red-600 hover:bg-red-50 rounded border border-gray-200 bg-white transition-all shadow-sm">
            {{'SERVCSTR0006' | translate}}
          </button>
        </div>
      </div>

      <div class="px-4 py-2 bg-white border-b border-gray-100 flex items-center justify-end gap-2 opacity-0">
        <input type="checkbox" id="sameAsMain" class="rounded border-gray-300 text-purple-600 focus:ring-purple-500" />
        <label for="sameAsMain" class=" font-medium cursor-pointer">{{'SERVCSTR0014' |
          translate}}</label>
      </div>

      <!-- Table Header -->
      <div class="grid grid-cols-12 bg-[#374151] border-b border-gray-200 text-gray-100  items-center">
        <div class="col-span-1 text-center flex justify-center items-center border-r  p-[0.4rem]">
          <p-checkbox [(ngModel)]="headerServiceChecked" [binary]="true" (onChange)="checkedAll(ser)"></p-checkbox>
        </div>
        <div class="col-span-3 border-r  p-[0.4rem]">{{'SERVCSTR0022' | translate}}</div>
        <div class="col-span-2 text-center text-ellipsis border-r  p-[0.4rem]">{{'SERVCSTR0023' | translate}}</div>
        <div class="col-span-2 text-center text-ellipsis border-r  p-[0.4rem]">{{'SERVCSTR0024' | translate}}</div>
        <div class="col-span-2 text-center text-ellipsis border-r  p-[0.4rem]">{{'SERVCSTR0025' | translate}}</div>
        <div class="col-span-2 text-center text-ellipsis  p-[0.4rem]">{{'SERVCSTR0026' | translate}}</div>
      </div>

      <div class="flex-1 overflow-y-auto p-0">
        @for (p of services(); track p.servicE_CD) {
        <div (click)="selectService(p)" class="grid grid-cols-12 rounded-lg border transition-all cursor-pointer"
          [class]="selectedService()?.servicE_CD === p.servicE_CD
              ? 'bg-purple-100 border-purple-300 border-l-4 border-l-purple-600 shadow-sm'
              : 'bg-white border-transparent hover:bg-gray-50 hover:border-gray-200'">
          <div class="col-span-1 text-center flex justify-center items-center border-r border-b p-[0.4rem]"
            (click)="$event.stopPropagation()">
            <p-checkbox [(ngModel)]="p.checked" [binary]="true" (ngModelChange)="changeCheck(ser)"></p-checkbox>
          </div>

          @if(selectedService()?.servicE_CD === p.servicE_CD){
          <div class="col-span-3 border-r p-[0.4rem]">
            <input type="text" [ngModel]="p.servicE_NM" maxlength="20" pInputText
              (ngModelChange)="updateNodeValue('PRODUCT', p.servicE_CD, 'servicE_NM', $event)"
              class="w-full outline-none  focus:bg-white h-[30px]"
              [class]="selectedService()?.servicE_CD === p.servicE_CD ? 'text-purple-900' : 'text-gray-700'"
              [placeholder]="'SERVCSTR0035'|translate" />
          </div>
          <div class="col-span-2 flex justify-center border-r  p-[0.4rem]">
            <p-inputnumber inputId="integeronly" [(ngModel)]="p.time" [min]="0" [max]="999" [clamp]="true"
              inputStyleClass="w-full text-center outline-none  h-[30px] text-gray-800  border-b border-transparent hover:border-gray-300 focus:border-indigo-500 transition-colors" />
          </div>
          <div class="col-span-2 flex justify-center border-r  p-[0.4rem]">
            <p-inputnumber inputId="integeronly" [(ngModel)]="p.price" [min]="0" [max]="999999999999999" [clamp]="true"
              inputStyleClass="w-full text-center outline-none  h-[30px] text-gray-800  border-b border-transparent hover:border-gray-300 focus:border-indigo-500 transition-colors" />
          </div>
          <div class="col-span-2 flex justify-center border-r  p-[0.4rem]">
            <p-inputnumber inputId="integeronly" [(ngModel)]="p.sort" [min]="1" [max]="9999" [clamp]="true"
              inputStyleClass="w-full text-center outline-none  h-[30px] text-gray-800  border-b border-transparent hover:border-gray-300 focus:border-indigo-500 transition-colors" />
          </div>
          <div class="col-span-2 flex justify-center p-[0.4rem]">
            <button
              (click)="$event.stopPropagation(); updateNodeValue('PRODUCT', p.servicE_CD, 'usE_YN', p.usE_YN === 'Y' ? 'N' : 'Y')"
              class="w-16 py-1 rounded-md   transition-all border" [class]="p.usE_YN === 'Y'
                ? 'bg-green-50 text-green-600 border-green-200 hover:bg-green-100'
                : 'bg-gray-50  border-gray-200 hover:bg-gray-100'">
              {{ (p.usE_YN === 'Y' ? 'SERVCEHQ0027' : 'SERVCEHQ0028') | translate }}
            </button>
          </div>

          }
          @else {
          <div class="col-span-3 border-r border-b p-[0.4rem]">
            <label class="text-ellipsis"> {{ p.servicE_NM }}</label>
          </div>
          <div class="col-span-2 flex justify-center border-r border-b p-[0.4rem]">
            <label> {{ p.time || 0 | number}}</label>
          </div>
          <div class="col-span-2 flex justify-center border-r border-b p-[0.4rem]">
            <label> {{ p.price | number }}</label>
          </div>
          <div class="col-span-2 flex justify-center border-r border-b p-[0.4rem]">
            <label> {{ p.sort | number}}</label>
          </div>
          <div class="col-span-2 flex justify-center border-b p-[0.4rem]">
            <label> {{ (p.usE_YN === 'Y' ? 'SERVCEHQ0027' : 'SERVCEHQ0028') | translate }}</label>
          </div>
          }
        </div>
        }
        @if (services().length === 0) {
        <div class="p-8 text-center text-gray-400 ">{{'SYSMESER0004' | translate}}</div>
        }
      </div>
    </div>
  </div>
</div>

<app-pop-up-common [showConfirm]="showConfirmDelete()" (confirmEvent)="delete()"
  (cancelEvent)="showConfirmDelete.set(false)" [message]="'SYSMESER0009'"></app-pop-up-common>